import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Grid,
} from "@material-ui/core";
import { MenuRounded, PowerSettingsNewRounded } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { navigate } from "@reach/router";

export default function NavBar(props) {
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  const { handleDrawerToggle } = props;

  /**
  |--------------------------------------------------
  | Custom Hook
  |--------------------------------------------------
  */
  const classes = useStyles();

  /**
  |--------------------------------------------------
  | Render
  |--------------------------------------------------
  */
  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar>
        <Box mr={2} display={{ sm: "none" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
          >
            <MenuRounded />
          </IconButton>
        </Box>

        <Grid container justify="space-between" alignItems="center">
          <p className="text-sm whitespace-no-wrap sm:text-lg">
            iGTB-Dashboard
          </p>

          <button onClick={() => navigate(`/signout`)}>
            <Box color="white" display={{ xs: "none", sm: "block" }}>
              <Grid container alignItems="center">
                <Box mr={1}>
                  <PowerSettingsNewRounded />
                </Box>
                <Typography variant="subtitle2">Sign out</Typography>
              </Grid>
            </Box>
          </button>
        </Grid>
      </Toolbar>
    </AppBar>
  );
}

/**
|--------------------------------------------------
| Custom Styles
|--------------------------------------------------
*/
const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  appBar: {
    marginLeft: drawerWidth,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
    },
  },
}));
